import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { selectUpdateTimeFrom, selectUpdateTimeTo } from '../selectors/selectFilters'
import { ILicenseEvent } from '../types/LicenseEvent'

export const fetchLicenseEvents = createAsyncThunk<
	ILicenseEvent[],
	string,
	ThunkConfig<string>
>('licenseEvents/fetchLicenseEvents', async (licenseId, thunkAPI) => {

	const { extra: { api }, rejectWithValue, getState } = thunkAPI

	const updateTimeFrom = selectUpdateTimeFrom(getState())
	const updateTimeTo = selectUpdateTimeTo(getState())

	try {
		const { data } = await api.get<{
			items: ILicenseEvent[]
		}>(`/licenses/${licenseId}/activity-log`, {
			params: {
				updateTimeFrom,
				updateTimeTo
			}
		})

		if (!Array.isArray(data?.items)) {
			console.warn('fetchLicenseEvents: unexpected response shape', data)
			return [] as ILicenseEvent[]
		}
		return data.items
	} catch (e) {
		console.log(e)
		appHandleError(e, 'fetchLicenseEvents', 'Failed to fetch license events')
		return rejectWithValue('Error occurred on fetching license events')
	}
})